import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, RouterStateSnapshot} from "@angular/router";
import {UtilsService} from "@shared-services/utils.service";
import {ConsoleContextService} from "@security/console-context.service";
import {ConsoleAuthenticationService} from "@security/console-authentication.service";
import {isNotEmpty, trimToNull} from "@ui-kit/framework/util/static/string-util";

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService{
  constructor(
    private auth: ConsoleAuthenticationService,
    private context: ConsoleContextService,
    private utilService: UtilsService,
  ) {
  }

  public canActivateRoute(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.validLogin() && this.verified()) {
      return true;
    }

    if (!this.tryNavigateToVerify(route.url.toString(), route.paramMap)) {
      let clientId = route.paramMap.get('clientId')?.replaceAll('null', '') ?? null;
      clientId = trimToNull(clientId);

      let queryParams: any = {}
      route.queryParamMap.keys.forEach(key => {
        queryParams[key] = route.queryParamMap.get(key);
      });

      if((queryParams.returnUrl === undefined || queryParams.returnUrl === null) && isNotEmpty(route.url.toString())){
        queryParams.returnUrl = route.url.toString();
      }
        this.auth.logout(true, clientId, queryParams);
    }
    return false;
  }

  /**
   * If the user is logged in but not verified, navigate to the verify page
   * @private
   * @return boolean - if the navigation was invoked
   */
  public tryNavigateToVerify(returnUri: string,
                             queryParams: any,
                             message: string | null = "Please verify your account to keep your profile secure."): boolean {
    if (this.validUnverifiedLogin()) {
      const uri = `/${this.context.getCurrentLandlordCode()!}/account/verify`;
      this.utilService.navigateWithQueryParams(uri, message,
        {
          ...queryParams,
          sendOtp: true,
          returnUrl: returnUri
        })
        .catch((error: string) => {
          console.log(error);
        });
      return true;
    }
    return false;
  }

  private validLogin(): boolean {
    return !!(this.auth.getToken() && this.auth.getExpiration() > new Date() && this.context.currentUser !== null);
  }

  private verified(): boolean {
    return this.auth.isVerified;
  }

  private validUnverifiedLogin(): boolean {
    return this.validLogin() && !this.verified();
  }


}
